import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Wrapper from '../components/atoms/Wrapper';
import Header from '../components/molecule/Header';
import Footer from '../components/molecule/Footer';
import Headline from '../components/atoms/Headline';
import Copy from '../components/atoms/Copy';

const StyledHeadline = styled(Headline)`
  margin-bottom: var(--distance-4xs);
`;

const LegalPage = () => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Header />
      <Wrapper>
        <StyledHeadline label={t('legal.headline')} />
        <Copy>
          <Trans t={t} i18nKey="legal.introduction">
          JT International Germany GmbH<br/>
          Im MediaPark 4e<br/>
          50670 Köln
          </Trans>
        </Copy>
        <Copy>
          <Trans t={t} i18nKey="legal.seat">
          Sitz der Gesellschaft:
          Trier, Registergericht Wittlich,
          Handelsregisternummer HRB 40577
          Umsatzsteueridentifikationsnummer JT
          International Germany GmbH: DE 813 205 039
          Geschäftsführer: Franz-Peter Kilburg, Jean Louis Cervesato, Marco Bordignon
          Aufsichtsratsvorsitzender: Stephan Rissmann
          </Trans>
        </Copy>
        <Copy>
          <Trans t={t} i18nKey="legal.comission">
          Die EU-Kommission stellt eine Plattform für außergerichtliche Streitschlichtung bereit. Verbrauchern gibt dies die Möglichkeit, Streitigkeiten im Zusammenhang mit Ihrer Online-Bestellung zunächst ohne die Einschaltung eines Gerichts zu klären. Die Streitbeilegungs-Plattform ist unter dem externen Link <a rel="nofollow" href="https://ec.europa.eu/consumers/odr">ec.europa.eu/consumers/odr</a> erreichbar.
          </Trans>
        </Copy>
        <Copy>
          <Trans t={t} i18nKey="legal.law_1">
          Gemäß § 36 <br/>
          Verbraucherstreitbeilegungsgesetz (VSBG) weisen wir darauf hin, dass wir nicht an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilnehmen und hierzu auch nicht verpflichtet sind.
          </Trans>
        </Copy>
        <Copy>
          <Trans t={t} i18nKey="legal.law_2">Verantwortlicher i.S.d. § 55 Abs. 2 RStV: Marco Bordignon, Im MediaPark 4e, 50670 Köln
          </Trans>
        </Copy>
        <Copy>
          <Trans t={t} i18nKey="legal.contact">
          E-Mail: <a href="email:info@camel.de">info@camel.de</a><br/>
          Telefon: <a href="tel:+49 221 1646 01">+49 221 1646 01</a><br/>
          oder nutzen Sie unser Kontaktformular unter <a rel="nofollow" href="https://www.jti.com">www.jti.com</a>
          </Trans>
        </Copy>
      </Wrapper>
      <Footer />
    </>
  )
};

export default LegalPage;
